import React from 'react';
import { Grid, Typography, Divider, styled, Box } from '@mui/material';
import Month from './Month';
import DefinedRanges from './DefinedRanges';
import { MARKERS } from './DateRangePicker';
import { MdiIcon } from '../../MdiIcon';
import { mdiArrowRightThin } from '@mdi/js';
import moment from 'moment';
export const Header = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));
export const HeaderItem = styled(Box)(() => ({
    flex: 1,
    textAlign: 'center'
}));
const Menu = (props) => {
    const { ranges, dateRange, minDate, maxDate, firstMonth, setFirstMonth, secondMonth, setSecondMonth, setDateRange, helpers, handlers } = props;
    const { startDate, endDate } = dateRange;
    const canNavigateCloser = moment(secondMonth).diff(moment(firstMonth), 'months') >= 2;
    const commonProps = { dateRange, minDate, maxDate, helpers, handlers };
    return (<Grid container direction='row' wrap='nowrap'>
      <Grid>
        <Grid container component={Header} alignItems='center' justifyContent='space-around'>
          <Grid item>
            <Typography variant='subtitle1'>{startDate ? moment(startDate).format('DD/MM/YYYY') : 'Data de Início'}</Typography>
          </Grid>
          <Grid item>
            <MdiIcon path={mdiArrowRightThin}/>
          </Grid>
          <Grid item>
            <Typography variant='subtitle1'>{endDate ? moment(endDate).format('DD/MM/YYYY') : 'Data de Fim'}</Typography>
          </Grid>
        </Grid>
        <Divider />
        <Grid container direction='row' wrap='nowrap'>
          <Month {...commonProps} value={firstMonth} setValue={setFirstMonth} navState={[true, canNavigateCloser]} marker={MARKERS.FIRST_MONTH}/>
          <Divider />
          <Month {...commonProps} value={secondMonth} setValue={setSecondMonth} navState={[canNavigateCloser, true]} marker={MARKERS.SECOND_MONTH}/>
        </Grid>
      </Grid>
      <Divider />
      <Grid>
        <DefinedRanges selectedRange={dateRange} ranges={ranges} setRange={setDateRange}/>
      </Grid>
    </Grid>);
};
export default Menu;
